<template>
  <div class="more_detail">
    <el-dialog
      ref="mRef"
      v-dialogDrag
      :title="title"
      :visible.sync="dialogVisible"
      :width="width"
      :modal="false"
      @close="beforeClose">
      <div class="item" v-for="item in morDetailConfig" :key="item.label">

      <!-- 默认模板 -->
        <template v-if="!item.slotName">
          <span>{{item.label}}</span><span>{{ detailData[item.field] }}</span>
        </template>

        <!-- 自定义模板 -->
        <template v-else>
          <slot :name="item.slotName" :item="item"></slot>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '30%'
    },
    detailDialogVisible: {
      type: Boolean,
      default: false
    },
    morDetailConfig: {
      type: Array,
      default: () => ([])
    },
    detailData: {
      type: Object,
      default: () => { }
    }
  },
  watch: {
    detailDialogVisible: {
      handler (flag) {
        this.dialogVisible = flag
        flag && this.setZindex()
      },
      immediate: true
    }
  },
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    beforeClose () {
      this.$emit('changeDialogVisible', false)
    },
    // 设置弹出框的zIndex
    setZindex () {
      this.$nextTick(() => {
        const el = this.$refs.mRef
        let zIndex = JSON.parse(localStorage.getItem('dialogZIndex'))
        zIndex = zIndex * 1 + 1
        el.$el.style.zIndex = zIndex
        localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      })
    }
  }
}
</script>

<style lang="less" scoped>
.more_detail{
 /deep/ .el-dialog__wrapper .el-dialog{
    height: auto !important;
  }
  /deep/ .el-dialog__body{
    max-height: 64vh;
    overflow: hidden;
    overflow-y: auto;
  }
}
.item {
  display: flex;
  margin-bottom: 10px;
}

span {
  padding: 10px 10px;
  border-radius: 3px;
  color: #FFF;
}

span:nth-child(1) {
  text-align: right;
  width: 90px;
  font-weight: 500;
}

span:nth-child(2) {
  flex: 1;
  background: #1F2C49;
}

 /deep/.el-dialog__body::-webkit-scrollbar {
   width: 6px;
   height: 6px;
 }

 /deep/.el-dialog__body::-webkit-scrollbar-thumb {
   border-radius: 5px;
   background: #42506E;
 }

 /deep/.el-dialog__body::-webkit-scrollbar-thumb:hover {
   border-radius: 5px;
   box-shadow: inset 0 0 5px rgba(28, 17, 17, 0.2);
   background: #42506E;
 }

 /deep/.el-dialog__body::-webkit-scrollbar-track {
   border-radius: 5px;
   background: #1F2C49;
 }

 /deep/.el-table__fixed-right-patch {
   background: #f8faff;
   border: 0;
 }
</style>
